export const CURRENT_LIFEMAP_USERNAME_KEY = 'currentLifemapUsername';
